//@ts-nocheck
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import ReactModal from 'react-modal';
import { addTriggeredEvent, viewSharedLinkReport } from '../../actions/UserActions';
import { UserState } from '../../interface/MyInterfaces';
import validator from 'validator';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

interface ViewReportState {
    isOpen?: boolean;
    email?: string;
    errormsg?: string;
    //submitClicked?: boolean;
}
interface ViewReportProps {
    UserState?: UserState;
    //username?: string;
    //display_id?: number;
    filetype?: string;
    addTriggeredEvent?(eventname, username, display_id, details);
    viewSharedLinkReport?(access);
}
class ViewReportModal extends React.Component<ViewReportProps, ViewReportState> {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: true,
            email: "",
            errormsg: "",
            //submitClicked: false
        };
    }
    onEmailChange = (e) => {
        const email = e.target.value;
        this.setState({ email });
    }
    //onSubmit
    //show reports & close the modal
    onSubmit = (e) => {
        const email = this.state.email;
        e.preventDefault();

        if (!email || !validator.isEmail(email)) {
            const errormsg = "Please provide a valid email."
            this.setState({ errormsg });
        } else {
            this.props.addTriggeredEvent(`Shared Report: ${this.props.filetype}`, email, this.props.UserState.report_display_id, "successful email entered");

            this.setState({ isOpen: false });
            //this.setState({ submitClicked: true });
            cookies.set('submitClicked', true, { expires: 0 });


        }
        this.props.viewSharedLinkReport("submit failed");
    }
    //onCancel
    //close the modal & reports with mask
    onCancel = () => {
        this.setState({ isOpen: false });
        this.props.viewSharedLinkReport(false);
        //open(location, '_self').close();
        //window.close();
    }
    clearErrorMsg = () => {
        this.setState({ errormsg: null });
    };
    public render() {
        const emailAlreadyProvided = cookies.get("submitClicked");
        return (
            <div>
                {!emailAlreadyProvided &&
                    <ReactModal
                        isOpen={this.state.isOpen}
                        contentLabel="enter email to view reports"
                        closeTimeOutMS={200}
                        className="modal--preview"
                    >
                        <form className="modal--preview__form" onFocus={this.clearErrorMsg}>
                            <p>Please enter your email address to view the {this.props.filetype.toLowerCase().replace("earlycareerreport", "early career researcher")} report</p>
                            <input className="modal--preview__input" onChange={this.onEmailChange} value={this.state.email} />
                            <p style={{ color: '#ef3d21', fontSize: '16px' }}>{this.state.errormsg}</p>
                            <div className="modal--preview__button">
                                <button onClick={this.onSubmit}>Submit</button>
                                <button onClick={this.onCancel}>Cancel</button>
                            </div>
                        </form>
                    </ReactModal>
                }
            </div>
        );
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            addTriggeredEvent: addTriggeredEvent,
            viewSharedLinkReport: viewSharedLinkReport
        }, dispatch
    )
}


const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties
});

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(ViewReportModal);
